import { useState } from "react";
import { Check, MessageCircle } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/context/LanguageContext";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import { isContactSaved, parseContact, saveContact } from "@/lib/saveContact";

// "Save your cart" box in the cart drawer: collects email or WhatsApp number before checkout.
export default function CartSaveContact() {
  const { items, subtotal } = useCart();
  const { t, lang } = useLang();
  const { customer } = useCustomerAuth() || {};
  const [value, setValue] = useState("");
  const [state, setState] = useState(isContactSaved() ? "done" : "idle");
  const [error, setError] = useState("");

  if (customer || items.length === 0) return null;
  if (state === "done") {
    return <div data-testid="cart-save-done" className="flex items-center gap-2 rounded-lg bg-emerald-50 border border-emerald-200 p-3 text-xs text-emerald-700"><Check className="w-4 h-4" /> {t("save_cart_done")}</div>;
  }

  const submit = async (e) => {
    e.preventDefault();
    const c = parseContact(value);
    if (!c) { setError(t("save_cart_invalid")); return; }
    setState("loading"); setError("");
    try { await saveContact({ ...c, items, subtotal, lang, source: "cart_drawer" }); setState("done"); }
    catch { setState("idle"); setError(t("save_cart_invalid")); }
  };

  return (
    <form onSubmit={submit} data-testid="cart-save-form" className="rounded-lg border border-xd-border bg-xd-light p-3 space-y-2">
      <div className="flex items-center gap-2 text-sm font-semibold"><MessageCircle className="w-4 h-4 text-[#25D366]" /> {t("save_cart_title")}</div>
      <p className="text-[11px] text-xd-muted leading-snug">{t("save_cart_desc")}</p>
      <div className="flex gap-2">
        <input value={value} onChange={(e) => setValue(e.target.value)} placeholder={t("save_cart_placeholder")} data-testid="cart-save-input" className="flex-1 min-w-0 rounded-md border border-xd-border bg-white px-3 py-2 text-sm" />
        <button type="submit" disabled={state === "loading"} data-testid="cart-save-btn" className="shrink-0 rounded-md bg-xd-dark px-3 py-2 text-xs font-semibold text-white hover:opacity-90 disabled:opacity-50">{t("save_cart_btn")}</button>
      </div>
      {error && <div data-testid="cart-save-error" className="text-[11px] text-red-600">{error}</div>}
      <p className="text-[10px] text-xd-muted">{t("save_cart_consent")}</p>
    </form>
  );
}
